/**
 * @description Converts a venezuelan telephone number with the shape +58 (###) ####### to
 * a local telephone number with the shape ##########
 * */
export function formatNumber(number: string): string {
    const venezuelanPattern = /^\+{1}[0-9]{2}\s{1}\([0-9]{3}\)\s{1}[0-9]{3}[0-9]{4}$/;
    if (venezuelanPattern.test(number)) {
        // delete the parenthesis and spaces from the number
        const numberWithoutParenthesis = number.replace(/\(|\)|\s/g, '');
        return numberWithoutParenthesis;
    }
    return number;
}

/**
 * @description Converts a national venezuelan number 0###-####### into an international venezuelan
 * telephone number with the shape +58 (###) #######
 * */
export function undoFormat(number: string, country: string): string {
    const PhoneNumber = require('awesome-phonenumber');
    const num = new PhoneNumber(number, country);
    if (country === 'VE') {
        // remove the first 0
        const numberWithoutFirstZero = num.getNumber('national').replace(/^0/, '');
        // get the local code
        const [localCode, restOfTheNumber] = numberWithoutFirstZero.split('-');
        // add the dial code
        return `+58 (${localCode}) ${restOfTheNumber}`;
    }
    // replace all the dashes with spaces.
    return num.getNumber('international').replace(/-/g, ' ');
}
